import { drinksLeft, drinksRight} from "./images"
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react"

import LoginModal from '../oauth/LoginModal';
import Header from "../LandingPage/Header";
import { FooterComponents } from './FooterComponents';



export default function Locations() {

    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);



    // Handle mobile menu scroll lock
    useEffect(() => {
        // Add the "no-scroll" class when the mobile menu is open
        if (isMobileMenuOpen) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }

        // Cleanup when the component unmounts or when isMobileMenuOpen changes
        return () => {
            document.body.classList.remove("no-scroll");
        };
    }, [isMobileMenuOpen]);



    return (
        <div className="overflow-hidden md:overflow-visible relative min-h-screen bg-white px-0 md:overflow-hidden">

            <Header setIsLoginOpen={setIsLoginOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} isMobileMenuOpen={isMobileMenuOpen} />


            {/* Left Side Drinks */}
            <div
                className="fixed left-0 top-24 bottom-0 md:w-24 lg:w-32 hidden md:block -ml-5"
                style={{
                    backgroundImage: `url(${drinksLeft || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>

            {/* Right Side Drinks */}
            <div
                className="fixed right-0 top-16 bottom-0 md:w-24 lg:w-32 hidden md:block -mr-5"
                style={{
                    backgroundImage: `url(${drinksRight || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>

            {/* Main content */}
            <div className="md:max-w-3xl xl:max-w-5xl mx-auto flex flex-col items-center justify-center min-h-screen text-center z-50">
                <h1 className="text-5xl md:text-6xl font-bold text-center mt-4 mb-2 text-[#2b0062]">Locations</h1>
                <h2 className="text-2xl md:text-2xl text-center  mb-12 text-[#2b0062]">Stay in the Know</h2>

                <div className="space-y-16 text-center">
                    <div>
                        <p className="text-2xl mb-4 md:text-2xl font-semibold text-[#2b0062]">
                            New York, New York
                        </p>
                        <a href="https://lastcallforbars.com/join/little-beaver" target="_blank" rel="noopener noreferrer" className="block text-xl text-[#2b0062] underline hover:opacity-80">Little Beaver</a>
                        <a href="https://lastcallforbars.com/join/heavy-woods" target="_blank" rel="noopener noreferrer" className="block text-xl text-[#2b0062] underline hover:opacity-80">Heavy Woods</a>
                        <a href="https://lastcallforbars.com/join/birdies-clubhouse" target="_blank" rel="noopener noreferrer" className="block text-xl text-[#2b0062] underline hover:opacity-80">Birdie's Clubhouse</a>

                    </div>

                    <div>
                        <p className="text-2xl mb-4 md:text-2xl font-semibold text-[#2b0062]">
                            East Lansing, Michigan
                        </p>
                        <a href="https://lastcallforbars.com/join/mash-bar" target="_blank" rel="noopener noreferrer" className="block text-xl text-[#2b0062] underline hover:opacity-80">Mash Bar</a>
                    </div>

                    <div>
                        <p className="text-2xl mb-4 md:text-2xl font-semibold text-[#2b0062]">
                            New Orleans, Louisiana
                        </p>
                        <a href="https://lastcallforbars.com/join/brunostavern" target="_blank" rel="noopener noreferrer" className="block text-xl text-[#2b0062] underline hover:opacity-80">Bruno's Tavern</a>
                    </div>

                    <div>
                        <p className="text-2xl mb-8 md:text-2xl text-[#2b0062]">
                            Want to hear from your favorite spot? Tell us!
                        </p>
                        <button className="bg-[#2b0062] text-[#FFFFFF] mb-10 px-20 py-3 rounded-full text-3xl font-bold hover:bg-opacity-90 transition-colors">
                            Refer a Venue
                        </button>
                    </div>
                </div>
                {/* Mobile Footer */}
                <div className="md:hidden mt-16">
                    <FooterComponents isMobile={true} setIsLoginOpen={setIsLoginOpen} />
                </div>

                {/* Desktop Footer */}
                <div className="hidden md:block mt-16">
                    <FooterComponents isMobile={false} setIsLoginOpen={setIsLoginOpen} />
                </div>
            </div>
            <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
        </div>
    )
}

